import React, { createContext, useContext } from "react";
const UserInfoContext = createContext(null);

const UserInfo = ({ children, context }) =>
{
	return (
		<UserInfoContext.Provider value={context}>
			{children}
		</UserInfoContext.Provider>
	);
}

export default UserInfo;

export const useUserInfo = () => useContext(UserInfoContext);
